import { OneTrustConfig } from './onetrust-config.token';

export const oneTrustScriptLoader = (oneTrustConfig: OneTrustConfig, document: Document, onload?: () => void) => {
    const head = document?.querySelector('head');
    if (!head.innerHTML.includes(`src="${oneTrustConfig.url}"`)) {
        const script = document.createElement('script');
        script.setAttribute('src', oneTrustConfig.url);
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('charset', 'UTF-8');
        script.setAttribute('data-domain-script', oneTrustConfig.domainScript);
        script.setAttribute('data-document-language', 'true');
        document.head.appendChild(script);
        script.onload = () => {
            onload && onload();
        };

        const script2 = document.createElement('script');
        script2.setAttribute('type', 'text/javascript');
        script2.innerHTML = `function OptanonWrapper() {}`;
        document.head.appendChild(script2);

        const styles = document.createElement('style');
        styles.setAttribute('type', 'text/css');
        styles.innerHTML = `@media print { #onetrust-consent-sdk { display: none !important; } }`;
        document.head.appendChild(styles);
    }
};
